import React, { useState, useEffect, useMemo } from 'react'
import { sum, throttle } from 'lodash'
import { useWatchableRef } from 'lib/hooks'
import { compactHash } from 'lib/utilities'
import { useClasses } from 'lib/utilities/react'

import { getClosestScrollContainer, isNearViewport } from '../utils/dom'
import { formatDayOfMessage } from '../utils'

import { Message } from './message'

function getChildrenHeights(container) {
  const children = Array.from(container.children);
  const results = [];

  children.forEach((child) => {
    const rect = child.getBoundingClientRect();
    const styles = window.getComputedStyle(child);

    const marginTop = parseFloat(styles.marginTop) || 0;
    const marginBottom = parseFloat(styles.marginBottom) || 0;

    const totalHeight = rect.height + marginTop + marginBottom;

    results.push({
      element: child,
      height: totalHeight
    });
  });

  return results;
}


export function MessageDay({date, messages, previousDate = null}) {
  const ref = useWatchableRef()
  const [ visible, setVisible ] = useState(true)
  const [ invisibleHeight, setInvisibleHeight ] = useState(null)

  useEffect((evt) => {
    if (!ref.current) return

    const container = getClosestScrollContainer(ref.current)
    const checkVisibility = throttle(() => {
      setVisible(isNearViewport(ref.current, { container, threshold: 1000 }))
    }, 500)
    container.addEventListener('scroll', checkVisibility)
    return () => container.removeEventListener('scroll', checkVisibility)
  }, [ref.version, setVisible])

  useEffect(() => {
    if (!visible || !ref.current) return

    setTimeout(() => {
      const heights = getChildrenHeights(ref.current)
    
      if (heights.length > 1) 
        setInvisibleHeight(sum(heights.map(item => item.height)))
    }, 50)
  }, [ref.version, visible, messages])

  const classes = useClasses([
    'message-day',
    visible ? null : 'placeholder'
  ])

  const style = useMemo(() => compactHash({
    minHeight: invisibleHeight
  }), [invisibleHeight])

  const children = useMemo(() => {
    if (!visible) return null
    
    return <>
      <div className="day">{formatDayOfMessage(date, previousDate)}</div>
      { messages.map(message => <Message key={message.id} message={message} />)}
    </>
  }, [ date, previousDate, messages, visible ])

  return <div className={classes} ref={ref.ref} style={style}>
    { children }
  </div>
}